import { Translate } from "react-localize-redux";
import Checkbox from "../../../../utils/components/Checkbox";

const SelectAllHeader = ({ titleId, checked, onChange, selected, total, disabled }) => (
  <div className="d-flex flex-column align-items-center gap-1 py-1">
    <span><Translate id={titleId} /></span>
    <Checkbox checked={checked} onChange={onChange} size="lg" disabled={disabled} />
    <small style={{ fontSize: "9px", whiteSpace: "nowrap", color: "#9e9e9e", opacity: disabled ? 0.4 : 1 }}>
      <Translate id="form_templates.authorization.select_all" /> ({selected}/{total})
    </small>
  </div>
);

export default SelectAllHeader;
